import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { Filter } from '@gogame/filters';

import {
  FILTER_FILTERSTATUSES,
  FILTER_NETWORKS,
  FILTER_PLATFORMS,
  FILTER_APPLICATIONS,
  FILTER_COUNTRIES,
  FILTER_CREATED_BY,
  FILTERS_DEPENDENCIES as DEPENDENCIES,
  FILTER_OWNERS,
  FILTER_TYPES,
} from 'scenes/CustomAudiences/Audiences/constants';
import * as filtersSource from 'scenes/CustomAudiences/Audiences/sources/filters';

export const Statuses = (props) => {
  return (
    <Filter.MultiSelect
      title={'Statuses'}
      name={FILTER_FILTERSTATUSES}
      source={filtersSource.loadFilterStatuses}
      depends={DEPENDENCIES[FILTER_FILTERSTATUSES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Networks = (props) => {
  return (
    <Filter.MultiSelect
      title={'Networks'}
      name={FILTER_NETWORKS}
      source={filtersSource.loadNetworks}
      withAll={false}
      depends={DEPENDENCIES[FILTER_NETWORKS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Platforms = (props) => {
  return (
    <Filter.MultiSelect
      title={'Platforms'}
      name={FILTER_PLATFORMS}
      source={filtersSource.loadPlatforms}
      withAll={false}
      depends={DEPENDENCIES[FILTER_PLATFORMS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Applications = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications'}
      name={FILTER_APPLICATIONS}
      source={filtersSource.loadApplications}
      depends={DEPENDENCIES[FILTER_APPLICATIONS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Countries = (props) => {
  return (
    <Filter.MultiSelect
      title={'Countries'}
      name={FILTER_COUNTRIES}
      source={filtersSource.loadCountries}
      depends={DEPENDENCIES[FILTER_COUNTRIES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const CreatedBy = (props) => {
  return (
    <UserFilter
      title={'Created By'}
      name={FILTER_CREATED_BY}
      source={filtersSource.loadCreatedBy}
      depends={DEPENDENCIES[FILTER_CREATED_BY]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Owners = (props) => {
  return (
    <UserFilter
      title={'Owners'}
      name={FILTER_OWNERS}
      source={filtersSource.loadOwners}
      depends={DEPENDENCIES[FILTER_OWNERS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Types = (props) => {
  return (
    <Filter.MultiSelect
      title={'Type'}
      name={FILTER_TYPES}
      source={filtersSource.loadTypes}
      placeholder={'All'}
      {...props}
    />
  );
};
